import { render, staticRenderFns } from "./BaseStatusEditor.vue?vue&type=template&id=5215d819&scoped=true&lang=pug&"
import script from "./BaseStatusEditor.vue?vue&type=script&lang=js&"
export * from "./BaseStatusEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5215d819",
  null
  
)

export default component.exports